const initState = {
    event: null,
    photos: null
}

const photobookReducer = (state = initState, action) => {
    return state;
}

export default photobookReducer; 